import DOMPurify from 'dompurify';

/** Keeps table layout and inline styles used by email signatures. */
export const sanitizeOutreachSignatureHtml = (html) => {
	if (!html) return '';
	return DOMPurify.sanitize(html, {
		USE_PROFILES: { html: true },
		ADD_ATTR: ['style', 'target', 'rel', 'cellpadding', 'cellspacing', 'border', 'colspan', 'rowspan'],
		ADD_TAGS: ['img'],
	});
};

export const signaturePreviewDocument = (bodyHtml) =>
	`<!DOCTYPE html><html><head><meta charset="utf-8"><base target="_blank"></head><body style="margin:16px;font-family:Arial,Helvetica,sans-serif;font-size:15px;color:#1e293b;">${bodyHtml || ''}</body></html>`;
